import {
  Component
} from '@angular/core';



@Component({
  selector: 'app-header-mobile',
  templateUrl: './header.mobile.component.html',
  styleUrl: './header.mobile.component.scss',
})
export class HeaderMobileComponent {

}